/**
 * Allow a promise to be queried (is fulfilled, is pending, is rejected)
 * @param {Promise} promise
 * @return {Promise}
 */
export default function(promise) {
  if (promise.isResovled) return promise;

  // Storage of the promises state.
  let isPending = true;
  let isRejected = false;
  let isFulfilled = false;

  // With a promise if it is already fulfilled it will immediately call then, so there isn't a concern of when this function
  // needs to be applied to the promise.
  let result = promise.then((v) => {
    isFulfilled = true;
    isPending = false;
    return v;
  }, (e) => {
    isRejected = true;
    isPending = false;
    throw e;
  });

  // Add methods to the Promise object, which can be used to view it's status.
  result.isFulfilled = () => { return isFulfilled; };
  result.isPending = () => { return isPending; };
  result.isRejected = () => { return isRejected; };

  return result;
};



// WEBPACK FOOTER //
// ./src/class/MakeQuerablePromise.js